import { graphql } from 'react-relay';

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { type FragmentRef } from '@confluence/apollo-relay-interop/entry-points/useFragmentizedQuery.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useFragmentizedFragment } from '@confluence/apollo-relay-interop/entry-points/useFragmentizedFragment.ts';

import type { ContentTypesHeaderQueryNode } from './ContentTypesHeader.tsx';
import type { useContentBasicInfoFragment$data } from './__generated__/useContentBasicInfoFragment.graphql.ts';

type ContentBasicInfo = Omit<useContentBasicInfoFragment$data, ' $fragmentType'>;
export const useContentBasicInfo = (
	contentBasicInfoRef: FragmentRef,
	externalShareContent?: ContentTypesHeaderQueryNode | null,
): ContentBasicInfo | null => {
	if (externalShareContent) {
		return {
			id: externalShareContent.id,
			title: externalShareContent.title,
			type: externalShareContent.type,
			subType: externalShareContent.subType ?? null,
			status: externalShareContent.status,
		};
	}

	// eslint-disable-next-line react-hooks/rules-of-hooks
	return useFragmentizedFragment<ContentBasicInfo>(
		graphql`
			fragment useContentBasicInfoFragment on Content {
				id
				title
				type
				subType
				status
			}
		`,
		contentBasicInfoRef,
	);
};
